<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-dropdown right
                          no-caret
                          variant="link"
                          boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom
                          title="Nueva Operación">
                <template #button-content>
                  <AppIcon name="add" label="Nueva Operación" />
                </template>
                <b-dropdown-item @click="add('add-manual')"><AppIcon name="add" /> Ingreso Manual</b-dropdown-item>
                <b-dropdown-item @click="add('sub-manual')"><AppIcon name="remove" /> Egreso Manual</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="add('transferencia')"><AppIcon name="sync_alt" /> Transferencia entre Depósito</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 240px; max-width: 360px;">
              <label class="filter-label">Buscar</label>
              <b-form-input type="text"
                            placeholder="Filtrar grilla"
                            v-model="table.filter"
                            size="sm">
              </b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 320px;">
              <label class="filter-label">Movimiento</label>
              <b-form-select
                size="sm"
                v-model="filters.operation_filter"
                :options="optOperationFilter"
                @change="setOperationFilter()"
              ></b-form-select>
            </div>
            <b-button variant="outline-dark"
                      size="sm"
                      @click="filterOperations()"
                      v-b-tooltip.hover
                      title="Aplicar filtros"
                      style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card no-body>
            <b-row>
              <b-col sm="12">
                <b-table class="app-table crud-operations-table"
                        ref="table"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        sticky-header="60vh"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="table.items"
                        :fields="table.fields"
                        :filter="table.filter"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        @row-clicked="onRowClicked"
                        :tbody-tr-class="rowClass"
                        :busy="table.isBusy"                      
                        v-if="table.items.length || table.isBusy">                       
                    
                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"                    
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template> 

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(id)="data">
                      <div v-if="data.item.type">
                        {{data.item.type.name}} #{{data.item.number}}                        
                      </div>
                    </template>

                    <template v-slot:cell(date)="data">
                      {{moment(data.item.date).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(reference_origin)="data">
                      <div v-if="data.item._origin" class="crud-operations-origin">
                        <b-badge pill
                                 :variant="data.item._origin.kind === 'cliente' ? 'info' : 'warning'"
                                 class="crud-operations-origin__badge">
                          <AppIcon :name="data.item._origin.kind === 'cliente' ? 'person' : 'truck'" />
                          {{ data.item._origin.kind === 'cliente' ? 'Cliente' : 'Proveedor' }}
                        </b-badge>
                        <span class="crud-operations-origin__name" v-b-tooltip.hover :title="data.item._origin.name">{{ data.item._origin.name }}</span>
                        <span class="crud-operations-origin__voucher">{{ data.item._origin.voucher }}</span>
                      </div>
                      <span v-else class="text-muted">—</span>
                    </template>

                    <template v-slot:cell(created_at)="data">
                      <span v-if="data.item.created_at" v-b-tooltip.hover :title="moment(data.item.created_at).format('DD/MM/YYYY HH:mm:ss')">
                        {{moment(data.item.created_at).format('DD/MM/YYYY HH:mm')}}
                      </span>
                    </template>

                    <template v-slot:cell(staff_id)="data">                      
                      <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name"> 
                        <b-avatar :src="data.item.staff.image"
                                  size="25px"
                                  v-if="data.item.staff.image">
                        </b-avatar>
                        <b-avatar v-else
                                  size="25px"
                                  :text="avatarFromName(data.item.staff.name).text"
                                  :style="avatarFromName(data.item.staff.name).style">
                        </b-avatar>              
                        <span v-if="isMobileViewport" class="ml-2">{{data.item.staff.name}}</span>
                      </span>               
                    </template>
                                        
                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.observations && !isStockCountOperation(data.item)">
                        <span v-if="isMobileViewport">{{data.item.observations}}</span>
                        <span v-else v-b-tooltip.hover :title="data.item.observations"><AppIcon name="chat-square-text" /></span>
                      </div>                                              
                    </template>

                    <template v-slot:cell(edit_source)="data">
                      <span v-if="isMobileViewport">{{getEditSourceLabel(data.item)}}</span>
                      <b-button
                        v-if="isStockCountOperation(data.item)"
                        :id="getStockCountPopoverId(data.item)"
                        variant="link"
                        size="sm"
                        class="p-0 stock-count-source-alert"
                        :class="getStockCountAlertClass(data.item)"
                      >
                        <AppIcon name="exclamation-triangle" fill />
                      </b-button>
                      <b-popover
                        v-if="isStockCountOperation(data.item)"
                        :target="getStockCountPopoverId(data.item)"
                        triggers="hover"
                        placement="right"
                        :custom-class="'stock-count-operation-popover ' + getStockCountAlertClass(data.item)"
                      >
                        <div class="stock-count-popover-title">
                          Ajuste generado por recuento
                        </div>
                        <div class="stock-count-popover-meta">
                          <div><strong>Staff:</strong> {{ data.item.staff ? data.item.staff.name : 'Sin staff' }}</div>
                          <div><strong>Fecha:</strong> {{ data.item.date ? moment(data.item.date).format('DD/MM/YYYY') : '-' }}</div>
                        </div>
                        <hr>
                        <div class="stock-count-popover-section">Contenido del ajuste</div>
                        <div
                          v-for="(activity, activityIndex) in data.item.activity"
                          :key="'stock-count-popover-activity-' + data.item.id + '-' + activityIndex"
                          class="stock-count-popover-row"
                        >
                          <div class="stock-count-popover-deposit">
                            <AppIcon name="warehouse" />
                            {{ getActivityDepositName(activity) }}
                          </div>
                          <div class="stock-count-popover-product" v-html="getDetailName(activity)"></div>
                          <div class="stock-count-popover-real">
                            <div class="stock-count-popover-real-label">Stock real ingresado</div>
                            <div v-html="formatStockCountUnits(getStockCountRealUnits(data.item, activity), ' / ')"></div>
                          </div>
                          <div class="stock-count-popover-qty" :class="activity.type_balance == '+' ? 'text-success' : 'text-danger'">
                            {{ activity.type_balance == '+' ? 'Se ajustó a la suba' : 'Se ajustó a la baja' }}:
                            <span v-html="formatStockCountUnits(getStockCountDiffUnits(data.item, activity), ' / ')"></span>
                          </div>
                        </div>
                      </b-popover>
                    </template>
                    
                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right 
                                  no-caret
                                  size="sm" 
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'crud-operations-action-toggle-labeled' : 'app-table-action-toggle'"
                                  :class="{ 'pull-right': !isMobileViewport }">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>
                        
                        <b-dropdown-item @click="openSub(data.item)">
                          <AppIcon name="visibility" /> Visualizar
                        </b-dropdown-item>
                        <b-dropdown-item @click="sendPrinterOperation(data.item)">
                          <AppIcon name="print" /> Imprimir
                        </b-dropdown-item>                          
                                                
                        <b-dropdown-header v-if="showDelete(data.item)">Acciones</b-dropdown-header>                      
                        <b-dropdown-item @click="remove(data.item)" v-if="showDelete(data.item)">
                          <AppIcon name="delete" class="text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else icon="warehouse" title="No se encontraron operaciones" description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá una operación nueva con el botón Agregar." />

                <div class="app-table-footer crud-operations-table-footer">
                  <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                  <export-excel
                    class="list-view-link"
                    :data="arr.export"
                    worksheet="Listado de Operaciones en Depósito"
                    name="list-operations-deposit.xls">
                    <AppIcon name="download" class="mr-1" /> Exportar
                  </export-excel>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>    

      <b-sidebar
          id="sidebar-operation-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle de la Operación"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.type">
                {{itemSelected.type.name}} #{{itemSelected.number}}
              </span>
              <div class="list-view-drawer__meta" v-if="itemSelected.date">
                {{moment(itemSelected.date).format('DD/MM/YYYY')}}
              </div>
              <div class="list-view-drawer__meta" v-if="itemSelected.staff">
                {{itemSelected.staff.name}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevOperation"
                        v-b-tooltip.hover
                        title="Operación anterior"
                        @click="goPrevOperation()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextOperation"
                        v-b-tooltip.hover
                        title="Operación siguiente"
                        @click="goNextOperation()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="app-modal-detail-list crud-operations-drawer-list">
            <div class="app-modal-detail-list__row" v-if="itemSelected.created_at">
              <span class="app-modal-detail-list__label">Registrado</span>
              <span class="app-modal-detail-list__value">{{ moment(itemSelected.created_at).format('DD/MM/YYYY HH:mm') }}</span>
            </div>
            <div class="app-modal-detail-list__row">
              <span class="app-modal-detail-list__label">Origen</span>
              <span class="app-modal-detail-list__value">
                <span v-if="getOrigin(itemSelected)" class="crud-operations-origin crud-operations-origin--stacked">
                  <b-badge pill :variant="getOrigin(itemSelected).kind === 'cliente' ? 'info' : 'warning'" class="crud-operations-origin__badge">
                    <AppIcon :name="getOrigin(itemSelected).kind === 'cliente' ? 'person' : 'truck'" />
                    {{ getOrigin(itemSelected).kind === 'cliente' ? 'Cliente' : 'Proveedor' }}
                  </b-badge>
                  <span class="crud-operations-origin__name">{{ getOrigin(itemSelected).name }}</span>
                  <span class="crud-operations-origin__voucher">{{ getOrigin(itemSelected).voucher }}</span>
                </span>
                <span v-else class="text-muted">—</span>
              </span>
            </div>
            <div class="app-modal-detail-list__row">
              <span class="app-modal-detail-list__label">Tipo de registro</span>
              <span class="app-modal-detail-list__value">{{ getEditSourceLabel(itemSelected) }}</span>
            </div>
          </div>

          <div v-if="itemSelected.observations && !isStockCountOperation(itemSelected)">
            <div class="list-view-drawer__section-title">
              <AppIcon name="chat-square-text" /> Observaciones
            </div>
            <p class="mb-3">{{ itemSelected.observations }}</p>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="list-ul" /> Detalle
            </div>

            <b-table  class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(quantity)="row"> 
                {{row.item.type_balance}} {{formatQuantity(row.item.quantity)}}
                <span v-if="row.item.unit_measurement">{{row.item.unit_measurement.reference}}</span>
              </template>

              <template v-slot:cell(product)="row">
                <div class="crud-operations-item-name" v-html="getDetailName(row.item)"></div>
              </template>

            </b-table>
            <EmptyState v-else icon="list-ul" title="Sin items cargados" />
          </div>

          <b-button v-if="tableSub.items.length"
                    block
                    size="sm"
                    variant="outline-secondary"
                    class="text-left"
                    @click="openDetail()">
            <AppIcon name="visibility" class="mr-1" /> Ver detalle completo
          </b-button>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="sendPrinterOperation(itemSelected)">
              <AppIcon name="print" class="mr-1" /> Imprimir
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && showDelete(itemSelected)">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-row>
        <b-col lg="12">  
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterOperations()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <DepositOperationFormModal ref="operationForm"
                                 @saved="filterOperations()" />

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              size="lg"
              :key="modal.detail._id"
              :id="modal.detail._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">{{this.modal.detail.title}}</h5>
        </div>
        <b-row>
          <b-col sm="12">                     
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab>
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <div class="app-modal-detail-list" v-if="itemSelected">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">ID</span>
                    <span class="app-modal-detail-list__value"><b>#{{this.itemSelected.id}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.type">
                    <span class="app-modal-detail-list__label">Comprobante</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.type.name + ' #' + this.itemSelected.number}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.staff">
                    <span class="app-modal-detail-list__label">Emisor</span>
                    <span class="app-modal-detail-list__value">{{itemSelected.staff.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.created_at">
                    <span class="app-modal-detail-list__label">Registrado</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.created_at).format('DD MMMM YYYY - HH:mm')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Origen</span>
                    <span class="app-modal-detail-list__value">
                      <span v-if="getOrigin(itemSelected)" class="crud-operations-origin crud-operations-origin--stacked">
                        <b-badge pill :variant="getOrigin(itemSelected).kind === 'cliente' ? 'info' : 'warning'" class="crud-operations-origin__badge">
                          <AppIcon :name="getOrigin(itemSelected).kind === 'cliente' ? 'person' : 'truck'" />
                          {{ getOrigin(itemSelected).kind === 'cliente' ? 'Cliente' : 'Proveedor' }}
                        </b-badge>
                        <span class="crud-operations-origin__name">{{ getOrigin(itemSelected).name }}</span>
                        <span class="crud-operations-origin__voucher">{{ getOrigin(itemSelected).voucher }}</span>
                      </span>
                      <span v-else class="text-muted">—</span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Tipo de registro</span>
                    <span class="app-modal-detail-list__value">{{getEditSourceLabel(itemSelected)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations && !isStockCountOperation(itemSelected)">
                    <span class="app-modal-detail-list__label">Observaciones</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observations}}</span>
                  </div>
                  <div class="app-modal-detail-list__row stock-count-detail-row"
                       v-if="isStockCountOperation(itemSelected)"
                       :class="getStockCountAlertClass(itemSelected)">
                    <span class="app-modal-detail-list__label">Ajuste</span>
                    <div class="app-modal-detail-list__value stock-count-detail-value">
                      <div class="stock-count-popover-title">Generado por recuento</div>
                      <div v-for="(activity, activityIndex) in itemSelected.activity"
                           :key="'stock-count-detail-activity-' + itemSelected.id + '-' + activityIndex"
                           class="stock-count-popover-row">
                        <div class="stock-count-popover-deposit">
                          <AppIcon name="warehouse" />
                          {{ getActivityDepositName(activity) }}
                        </div>
                        <div class="stock-count-popover-product" v-html="getDetailName(activity)"></div>
                        <div class="stock-count-popover-real">
                          <div class="stock-count-popover-real-label">Stock real ingresado</div>
                          <div v-html="formatStockCountUnits(getStockCountRealUnits(itemSelected, activity), ' / ')"></div>
                        </div>
                        <div class="stock-count-popover-qty"
                             :class="activity.type_balance == '+' ? 'text-success' : 'text-danger'">
                          {{ activity.type_balance == '+' ? 'Se ajustó a la suba' : 'Se ajustó a la baja' }}:
                          <span v-html="formatStockCountUnits(getStockCountDiffUnits(itemSelected, activity), ' / ')"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>              
              <b-tab>
                <template #title><AppIcon name="list-ul" class="mr-1" /> Items</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetail.items"
                        :fields="tableDetail.fields"
                        v-if="tableDetail.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(product)="data">
                    <div class="crud-operations-item-cell">
                      <div class="crud-operations-item-cell__code" v-html="getDetailCode(data.item)"></div>
                      <div class="crud-operations-item-cell__name"
                           :class="{ 'text-truncate': !isMobileViewport }"
                           v-b-tooltip.hover
                           :title="getDetailName(data.item)"
                           v-html="getDetailName(data.item)"></div>
                    </div>
                  </template>

                  <template v-slot:cell(quantity)="data">   
                    {{data.item.type_balance}} {{formatQuantity(data.item.quantity)}}
                    <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                  </template>
                  
                  <template v-slot:cell(deposit)="data">   
                    <DepositLocationLabel :location="data.item.location" />
                  </template>

                </b-table>
                <EmptyState v-else icon="list-ul" title="No se encontraron registros" />
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>                   
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Printer from '@/components/inc/printer/printer'
  import moment from 'moment'
  import Function from '@/handler/funciones'
  import StorageLocal from '@/handler/storageLocal'
  import DepositOperationFormModal from './inc/DepositOperationFormModal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      Printer,
      DepositOperationFormModal,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudDepositsOperations',
          elements: {}
        },
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,          
        },     
        tableSub : {
          items: [],
          fields: []
        },            
        tableDetail : {
          items: [],
          fields: []
        },            
        crud: {
          form: {
            id: 0,
          },
          print: {
            reference: 'deposit-operation',
            id: 0,
            key: 0,
          }               
        },
        modal: {
          detail: {
            active: false, 
            title: '',
          },            
        },          
        arr: {
          operations: [],   
          export: [],           
        },           
        filters: {
          date_start: '',
          date_end: '',
          type_reference: '',
          edit_source: '',
          operation_filter: '',
        },
        optOperationFilter: [
          { value: '', text: 'Todos los movimientos' },
          {
            label: 'Tipos de operación',
            options: [
              { value: 'type:add-manual', text: 'Ingreso manual' },
              { value: 'type:sub-manual', text: 'Egreso manual' },
              { value: 'type:transferencia', text: 'Transferencia entre depósito' },
              { value: 'type:sub-remito', text: 'Egreso desde venta' },
              { value: 'type:add-remito', text: 'Ingreso desde remito de compra' },
              { value: 'type:return-nc', text: 'Devolución por nota de crédito' },
            ]
          },
          {
            label: 'Origen',
            options: [
              { value: 'source:stockCount', text: 'Ajustes por recuento' },
            ]
          },
        ],
        itemSelected: null,
        detailDrawer: false,
        filtersOpen: false,
        isMobileViewport: false,
      }
    },
    created () {     
        /* Configurar permisos de vistas y elementos */
        Helper.hasAccessView(this.access)
        /* Fin configuracion */
    },     
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_deposits_operations') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()
      this.filterLoad()
      this.filterOperations()

      // Acción directa desde la paleta de comandos: abrir el alta al entrar.
      if (this.$route.query.new == '1') {
        this.add(this.$route.query.mode || 'add-manual')
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.filterLoad()
      this.filterOperations()

      // Misma acción directa que en mounted(): si la pestaña ya estaba
      // montada (keep-alive), "mounted" no vuelve a correr y la paleta de
      // comandos no abriría nada sin este chequeo acá también.
      if (this.$route.query.new == '1') {
        this.add(this.$route.query.mode || 'add-manual')
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }
    },
    computed: {
      currentOperationIndex() {
        if(!this.itemSelected) return -1
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevOperation() {
        return this.currentOperationIndex > 0
      },
      canGoNextOperation() {
        return this.currentOperationIndex >= 0 && this.currentOperationIndex < this.table.items.length - 1
      },
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_crud_deposits_operations', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Function.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: options.size || 'sm',
          buttonSize: options.buttonSize || 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      // CONFIGURACION
      loadFieldTable () {
        this.table.fields = []
        this.tableSub.fields = []
        this.tableDetail.fields = []

        // TABLE OPERATIONS        
        this.table.fields.push({key: 'staff_id', label: 'Staff', class:"align-middle " + this.alignClass('text-center'), width:"60px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-center'), width:"90px"})
        this.table.fields.push({key: 'id', label: 'Nº Operación', sortable: true, class:"align-middle " + this.alignClass('text-left'), width:"150px"})
        this.table.fields.push({key: 'reference_origin', label: 'Origen', class:"align-middle " + this.alignClass('text-left'), width:"220px"})
        this.table.fields.push({key: 'created_at', label: 'Registrado', class:"align-middle " + this.alignClass('text-center'), width:"120px"})
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"45px"})
        this.table.fields.push({key: 'edit_source', label: this.isMobileViewport ? 'Tipo de registro' : '', class:"align-middle " + this.alignClass('text-center'), width:"45px"})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"60px"})

        // TABLE DETALLE
        this.tableSub.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle text-left", width:"80px"})                
        this.tableSub.fields.push({key: 'product', label: 'Item', class:"align-middle text-left", width:"180px"})                

        // TABLE DETALLE COMPLETO        
        this.tableDetail.fields.push({key: 'product', label: 'Item', class:"align-middle " + this.alignClass('text-left'), width:"240px"})                                         
        this.tableDetail.fields.push({key: 'deposit', label: 'Depósito/Zona/Ubicación', class:"align-middle " + this.alignClass('text-left'), width:"180px"})          
        this.tableDetail.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-right'), width:"80px"})                     
      },      
      getRowCount (items) {
        return items.length
      },
      formatQuantity(value) {
        const num = parseFloat(value)
        if (Number.isNaN(num)) {
          return (0).toFixed(4)
        }
        return num.toFixed(4)
      },
      setOperationFilter() {
        this.filters.type_reference = ''
        this.filters.edit_source = ''

        if(!this.filters.operation_filter) {
          return
        }

        var parts = this.filters.operation_filter.split(':')
        if(parts[0] == 'type') {
          this.filters.type_reference = parts[1]
        }
        if(parts[0] == 'source') {
          this.filters.edit_source = parts[1]
        }
      },
      isStockCountOperation(item) {
        return item && item.edit_source == 'stockCount'
      },
      getEditSourceLabel(item) {
        if(!item) return ''
        if(item.edit_source == 'stockCount') return 'Ajuste por recuento'
        if(this.getOrigin(item)) return 'Generado por comprobante'
        return 'Manual'
      },
      // Devuelve { kind: 'cliente'|'proveedor', name, voucher } segun el comprobante
      // que originó la operación (remito de venta, NC de venta, o remito de compra).
      getOrigin(item) {
        if(!item) return null
        var sr = item.sale_remit
        var pr = item.purchase_remit
        var ndc = item.sale_detail_nc && item.sale_detail_nc.sale ? item.sale_detail_nc.sale : null

        if(sr && sr.customer) {
          return { kind: 'cliente', name: sr.customer.name, voucher: this.formatOriginVoucher(sr.type_voucher, sr.point_sale, sr.number) }
        }
        if(ndc && ndc.customer) {
          return { kind: 'cliente', name: ndc.customer.name, voucher: this.formatOriginVoucher(ndc.type_voucher, ndc.point_sale, ndc.number) }
        }
        if(pr && pr.supplier) {
          return { kind: 'proveedor', name: pr.supplier.name, voucher: this.formatOriginVoucher(pr.type_voucher, pr.points_sales, pr.number) }
        }
        return null
      },
      formatOriginVoucher(typeVoucher, pointSale, number) {
        var name = typeVoucher && typeVoucher.name ? typeVoucher.name : 'Comprobante'
        // pointSale puede venir como objeto (relación) o como número (columna)
        var ps = (pointSale && typeof pointSale === 'object') ? pointSale.point_sale : pointSale
        return name + ' ' + String(ps || 0).padStart(4, '0') + '-' + String(number || 0).padStart(8, '0')
      },
      getStockCountPopoverId(item) {
        return 'stock-count-operation-popover-' + item.id
      },
      getActivityDepositName(activity) {
        if(activity && activity.location && activity.location.zone && activity.location.zone.deposit) {
          return activity.location.zone.deposit.name
        }
        return 'Sin depósito'
      },
      getStockCountData(item) {
        if(!item || !item.observations) return null
        try {
          var data = JSON.parse(item.observations)
          return data && data.source == 'stockCount' ? data : null
        } catch (e) {
          return null
        }
      },
      getStockCountRealUnits(item, activity) {
        var data = this.getStockCountData(item)
        if(data) {
          return this.getStockCountUnits(data.real_purchase, data.purchase_unit, data.real_sale, data.sale_unit)
        }
        return this.getStockCountUnits(activity.quantity, activity.unit_measurement ? activity.unit_measurement.reference : '', activity.quantity_sale, activity.unit_measurement_sale_reference)
      },
      getStockCountDiffUnits(item, activity) {
        var data = this.getStockCountData(item)
        if(data) {
          return this.getStockCountUnits(Math.abs(data.diff_purchase), data.purchase_unit, Math.abs(data.diff_sale), data.sale_unit)
        }
        return this.getStockCountUnits(activity.quantity, activity.unit_measurement ? activity.unit_measurement.reference : '', activity.quantity_sale, activity.unit_measurement_sale_reference)
      },
      getStockCountUnits(purchaseQuantity, purchaseUnit, saleQuantity, saleUnit) {
        var units = [{
          quantity: purchaseQuantity,
          unit: purchaseUnit || ''
        }]

        if(saleQuantity !== undefined && saleQuantity !== null && saleUnit && saleUnit != purchaseUnit) {
          units.push({
            quantity: saleQuantity,
            unit: saleUnit
          })
        }

        return units
      },
      formatStockCountUnits(units, separator = ' ') {
        return units
          .map(unit => '<span class="stock-count-popover-unit">' + this.formatQuantity(unit.quantity) + (unit.unit ? ' ' + unit.unit : '') + '</span>')
          .join(separator)
      },
      getStockCountAlertClass(item) {
        var type = this.getStockCountMovementType(item)
        if(type == 'add') return 'stock-count-movement-add'
        if(type == 'sub') return 'stock-count-movement-sub'
        return 'stock-count-movement-mixed'
      },
      getStockCountMovementType(item) {
        var hasAdd = false
        var hasSub = false
        if(item && item.activity) {
          item.activity.forEach(activity => {
            if(activity.type_balance == '+') hasAdd = true
            if(activity.type_balance == '-') hasSub = true
          })
        }
        if(hasAdd && !hasSub) return 'add'
        if(hasSub && !hasAdd) return 'sub'
        return 'mixed'
      },
      // SELECT         
      prepareExport(data) {              
        this.arr.export = []
        data.forEach(element => {
          var voucherReference = ""
 
          if(element.type) {            
            voucherReference = element.type.name + ' #' + element.number
          }          

          this.arr.export.push({
            id: element.id,
            date: element.date,
            voucherReference: voucherReference,
            observations: element.observations,
            productID: 0,
            productCode: "",
            productName: "",            
            productCompoundID: 0,
            productCompoundName: "",                                          
            type_balance: "",
            quantity: 0,
            unitMeasurementID: 0,
            unitMeasurementName: "",                        
          })

          element.activity.forEach(element1 => {
            var productID = 0
            var productCode = ""
            var productName = ""
            var productCompoundID = 0
            var productCompoundName = ""     
            var unitMeasurementID = 0
            var unitMeasurementName = ""               

            if(element1.products_id) {
              productID = element1.product.id
              productCode = element1.product.code
              productName = element1.product.name            
            }

            if(element1.products_colors_id) {
              productID = element1.products_color.id
              productCode = element1.products_color.code
              productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
            }            

            if(element1.products_waist_id) {
              productID = element1.products_waist.id
              productCode = element1.products_waist.code
              productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
            }            

            if(element1.products_color_waist_id) {
              productID = element1.products_color_waist.id
              productCode = element1.products_color_waist.code
              productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
            }       
          
            if(element1.products_compound_id) {
              productCompoundID = element1.products_compound.id
              productCompoundName = element1.products_compound.name            
            }    

            if(element1.unit_measurement_id) {
              unitMeasurementID = element1.unit_measurement.id
              unitMeasurementName = element1.unit_measurement.name            
            }            

            this.arr.export.push({
              productID: productID,
              productCode: productCode,
              productName: productName,
              productCompoundID: productCompoundID,
              productCompoundName: productCompoundName,                                          
              type_balance: element1.type_balance,
              quantity: element1.quantity,
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,              
            })
          })
        });
      },

      // ABM MAIN
      add(type) {
        this.$refs.operationForm.add(type)
      },
      remove(item) {
        this.crud.form.id = item.id

        var voucher = "ID #" + item.id
        
        if(item.type) {
          voucher = item.type.name + '- #' + item.number.toString().padStart(8,'0')
        }         

        this.confirmDialog('¿Desea borrar la operación ' + voucher + '?', {
          title: 'Borrar Operación',
          size: 'lg',
          buttonSize: 'lg',
          okTitle: 'SI',
          cancelTitle: 'NO',
          danger: true,
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarOperacion(this.crud.form.id);

            result.then(() => {      
              this.$refs.operationForm.close()        
              loader.hide()
              this.filterOperations()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      showDelete(item) {
        if(!item || !item.type) return false

        if(item.type.reference == 'add-manual' || item.type.reference == 'sub-manual' || item.type.reference == 'transferencia' ) {
          return true
        } else {
          return false
        }
      },


      // FILTER
      filterLoad() {      
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
      },          
      filterOperations(forceOpenSub=false) {
        this.table.isBusy = true
        var result = serviceAPI.filtrarOperacion(this.filters, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data
          this.table.tablePaginate = data

          // Precalcula el origen (cliente/proveedor + comprobante) una vez por fila.
          data.data.forEach(row => { row._origin = this.getOrigin(row) })

          this.table.items = data.data
          this.arr.operations = data.data
          this.prepareExport(data.data)
          
          if(forceOpenSub && this.itemSelected) {
            var selected = this.table.items.find(element => element.id == this.itemSelected.id)
            if(selected) {
              this.openSub(selected)
            } else {
              this.hideSub()
            }
          }

          if(this.$refs.table) {            
            this.$refs.table.$forceUpdate()
          }          
          
          this.table.isBusy = false
        })           
        .catch(error => { 
          this.table.isBusy = false  
          this.$awn.alert(ErrorToken.valid(error));
        })  
      },    

      // OPERATION DETAIL
      openSub(item) {                
        this.itemSelected = item        

        this.tableSub.items = item.activity           
        this.detailDrawer = true
      },    
      hideSub() {
        this.tableSub.items=[]
        this.itemSelected = null
        this.detailDrawer = false
      },               
      goPrevOperation() {
        if(!this.canGoPrevOperation) return
        var item = this.table.items[this.currentOperationIndex - 1]
        if(item) this.openSub(item)
      },
      goNextOperation() {
        if(!this.canGoNextOperation) return
        var item = this.table.items[this.currentOperationIndex + 1]
        if(item) this.openSub(item)
      },
      openDetail() {              
        this.tableDetail.items = this.itemSelected.activity

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle de la operación"
        this.modal.detail.active = true
      }, 
      getDetailCode(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }            
        if(item.products_compound_id) {          
          return item.products_compound.code
        }                
      },
      getDetailName(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }               
        if(item.products_compound_id) {          
          return item.products_compound.name
        }                
      },       
      getProductCode(item) {
        if(item.products_id) {
          return item.product.code
        }

        if(item.products_colors_id) {
          var prodColor = item.products_color 
          return prodColor.code
        }

        if(item.products_waist_id) {
          var prodWaist = item.products_waist 
          return prodWaist.code
        }

        if(item.products_color_waist_id) {
          var prodColorWaist = item.products_color_waist 
          return prodColorWaist.code
        }
      },      
      getProductName(item) {
        if(item.products_id) {
          return item.product.name
        }

        if(item.products_colors_id) {
          var prodColor = item.products_color 
          return prodColor.name + ' (' + prodColor.color.name + ')'
        }

        if(item.products_waist_id) {
          var prodWaist = item.products_waist 
          return prodWaist.name + ' (' + prodWaist.waist.name + ')'
        }

        if(item.products_color_waist_id) {
          var prodColorWaist = item.products_color_waist 
          return prodColorWaist.name + ' (' + prodColorWaist.color.name + ' - ' + prodColorWaist.waist.name + ')'
        }
      },

      // PRINT
      sendPrinterOperation(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      }      
    }
  }
</script>
<style>
  .crud-operations-title {
    font-size: 15px;
    font-weight: 600;
  } 
  .stock-count-source-alert {
    color: #f0ad4e;
    font-size: 1rem;
    line-height: 1;
  }
  .stock-count-source-alert.stock-count-movement-add {
    color: #4dbd74;
  }
  .stock-count-source-alert.stock-count-movement-sub {
    color: #f86c6b;
  }
  .stock-count-source-alert.stock-count-movement-mixed {
    color: #f0ad4e;
  }
  .stock-count-source-alert.stock-count-movement-add:hover {
    color: #2f9d55;
  }
  .stock-count-source-alert.stock-count-movement-sub:hover {
    color: #d9534f;
  }
  .stock-count-source-alert.stock-count-movement-mixed:hover {
    color: #d9831f;
  }
  .stock-count-operation-popover {
    max-width: 360px;
  }
  .stock-count-operation-popover.stock-count-movement-add {
    border-color: #9fdab4;
  }
  .stock-count-operation-popover.stock-count-movement-sub {
    border-color: #f5b5b5;
  }
  .stock-count-operation-popover.stock-count-movement-mixed {
    border-color: #f0d98a;
  }
  .stock-count-operation-popover .popover-body {
    border-radius: 0.25rem;
    font-size: 0.85rem;
    min-width: 320px;
  }
  .stock-count-operation-popover.stock-count-movement-add .popover-body {
    color: #235734;
    background: #eaf8ef;
  }
  .stock-count-operation-popover.stock-count-movement-sub .popover-body {
    color: #7a2b2b;
    background: #fdecec;
  }
  .stock-count-operation-popover.stock-count-movement-mixed .popover-body {
    color: #5f4b00;
    background: #fff3cd;
  }
  .stock-count-operation-popover hr {
    margin: 0.5rem 0;
  }
  .stock-count-operation-popover.stock-count-movement-add hr {
    border-top-color: #bfe6cc;
  }
  .stock-count-operation-popover.stock-count-movement-sub hr {
    border-top-color: #f3c3c3;
  }
  .stock-count-operation-popover.stock-count-movement-mixed hr {
    border-top-color: #e6d27a;
  }
  .stock-count-popover-title {
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03rem;
    margin-bottom: 0.4rem;
  }
  .stock-count-popover-meta {
    line-height: 1.45;
  }
  .stock-count-popover-section {
    font-weight: 700;
    margin-bottom: 0.35rem;
  }
  .stock-count-popover-row {
    padding-top: 0.35rem;
  }
  .stock-count-popover-row + .stock-count-popover-row {
    border-top: 1px solid #e6d27a;
    margin-top: 0.35rem;
  }
  .stock-count-popover-deposit {
    font-size: 0.76rem;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 0.25rem;
    opacity: 0.82;
  }
  .stock-count-popover-qty {
    font-weight: 700;
    margin-top: 0.45rem;
  }
  .stock-count-popover-real {
    margin-top: 0.45rem;
    padding: 0.45rem 0.55rem;
    border-radius: 0.35rem;
    background: rgba(32, 168, 216, 0.12);
    color: #165d78;
    font-size: 0.95rem;
  }
  .stock-count-popover-real-label {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 0.15rem;
  }
  .stock-count-popover-unit {
    display: inline-block;
    margin-right: 0.35rem;
    font-weight: 700;
  }
  .stock-count-popover-product {
    margin-top: 0.15rem;
  }
  .stock-count-detail-row .app-modal-detail-list__value {
    min-width: 0;
  }
  .stock-count-detail-value {
    display: block;
    padding: 0.6rem 0.7rem;
    border-radius: 0.35rem;
  }
  .stock-count-detail-row.stock-count-movement-add .stock-count-detail-value {
    color: #235734;
    background: #eaf8ef;
  }
  .stock-count-detail-row.stock-count-movement-sub .stock-count-detail-value {
    color: #7a2b2b;
    background: #fdecec;
  }
  .stock-count-detail-row.stock-count-movement-mixed .stock-count-detail-value {
    color: #5f4b00;
    background: #fff3cd;
  }
  .crud-operations-item-cell {
    padding: 6px 0;
  }
  .crud-operations-item-cell__code {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    margin-bottom: 2px;
  }
  .crud-operations-item-cell__name {
    line-height: 1.35;
  }
  .crud-operations-item-cell__name:not(.text-truncate),
  .crud-operations-item-name:not(.text-truncate) {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
  .crud-operations-item-name {
    line-height: 1.35;
  }
  .crud-operations-table-footer {
    padding-right: 12px;
  }
  .btn.crud-operations-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-operations-action-toggle-labeled:hover,
  .btn.crud-operations-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-operations-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-operations-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      align-items: flex-start;
      padding-top: 10px !important;
    }
  }
  .operations-alert-retailer {
    font-weight: bold;
    color: gray;
    font-size: 12px;
  }
  .operations-alert-noretailer {
    font-weight: bold;
    color: darkblue;
    font-size: 12px;
  } 
  .operation-total-table-paid {
    color: darkgreen;
    font-weight: 700;
  } 
  .operation-total-table-nopaid {
    color: darkred;
    font-weight: 700;
  }
  .crud-operations-nro-internal {
    color: #6200ee;
    font-size: 12px;
  }
  .crud-new-operations-button-add {
    margin-top: 29px;
  }
  .crud-operations-totales-items-header {
    background: var(--dark);
    color: #fff;
    font-size: 12px;
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom: 2px;    
    text-align: right;
    font-weight: 700;
  }
  .crud-operations-counts-items {
    font-size: 12px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: solid;
    border-width: 1px;    
  }  
  .crud-operations-totales-items {
    font-size: 12px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: dotted;
    border-width: 1px;    
  }  
  .crud-operations-totales-items-amount {
    font-size: 15px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: dotted;    
    border-width: 1px;    
  }    
  .crud-operations-totales-discounts-items {
    padding-top: 5px;
  }

  /* Origen (cliente / proveedor) en grilla, sidebar y modal */
  .crud-operations-origin {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 8px;
    min-width: 0;
  }
  .crud-operations-origin--stacked {
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
  }
  .crud-operations-origin__badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.03em;
    flex: 0 0 auto;
  }
  .crud-operations-origin__badge .app-icon {
    font-size: 13px;
  }
  .crud-operations-origin__name {
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  .crud-operations-origin--stacked .crud-operations-origin__name {
    white-space: normal;
  }
  .crud-operations-origin__voucher {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    white-space: nowrap;
  }

  /* Mini-tabla vertical del sidebar: label más angosto que en el modal */
  .crud-operations-drawer-list {
    margin-bottom: 12px;
  }
  .crud-operations-drawer-list .app-modal-detail-list__label {
    flex: 0 0 110px;
  }
</style>
